import React, { FC } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import classnames from 'classnames'
import { RichSnippetNewsArticle } from '@components/shared/rich-snippets'

const baseUrl = process.env.NEXT_PUBLIC_URL_BASE

interface Props {
  articles: any[]
  className?: string
  includeRichSnippets?: boolean
  priorityIndexes?: number[] // Índices das imagens que devem ter priority
}

export const ArticlesBlock: FC<Props> = ({
  articles,
  className,
  includeRichSnippets = true,
  priorityIndexes = []
}) => {
  return (
    <div className={classnames('flex gap-6 flex-col md:flex-row', className)}>
      {articles?.map((article, index) => {
        return (
          <React.Fragment key={index.toString()}>
            {includeRichSnippets && (
              <RichSnippetNewsArticle
                title={article?.title}
                path={baseUrl + article?.path}
                images={article?.thumbnailImage?.path}
                dateModified={article?.updatedAt}
                datePublished={article?.publishedAt}
                author={article?.authors?.map(author => ({
                  name: author?.name,
                  path: baseUrl + author?.path
                }))}
              />
            )}

            <Link
              href={article?.path || `/${article?.slug}`}
              className="cursor-pointer font-noto w-full h-full flex flex-col"
              prefetch={priorityIndexes.includes(index)}
            >
              <div
                className="bg-white overflow-hidden"
                style={{ height: '384px' }}
              >
                <div
                  className="relative"
                  style={{ height: '192px', width: '100%' }}
                >
                  <Image
                    src={
                      article?.thumbnailImage?.path ||
                      '/assets/default-article.jpg'
                    }
                    alt={article?.thumbnailImage?.alt || article?.title}
                    fill
                    className="object-cover rounded-lg"
                    priority={priorityIndexes.includes(index)}
                    loading={
                      priorityIndexes.includes(index) ? undefined : 'lazy'
                    }
                    quality={priorityIndexes.includes(index) ? 85 : 75}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    placeholder="blur"
                    blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAj/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCwAB//2Q=="
                    fetchPriority={
                      priorityIndexes.includes(index) ? 'high' : 'auto'
                    }
                  />
                </div>
                <div className="md:col-span-2 flex flex-col md:pt-0 md:ps-4 relative pb-4 pt-2">
                  <span className="bg-green w-fit text-white px-3 py-1 rounded text-sm font-medium mr-2 my-2 ">
                    {article?.editorialAscendent
                      ? article.editorialAscendent.name
                      : article.editorial?.name || 'NOTÍCIA'}
                  </span>
                  <h3 className="font-bold text-lg mb-2 h-14 overflow-hidden">
                    {article.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-2 line-clamp-3">
                    {article?.shortContent ||
                      'Conteúdo da notícia em destaque.'}
                  </p>
                  <p className="text-xs text-gray-500 flex justify-between w-full absolute bottom-1">
                    <span>
                      {new Date(
                        article?.publishedAt || article?.createdAt
                      ).toLocaleDateString('pt-BR')}
                    </span>
                    <span className="pe-2">
                      {article?.timeToRead || 4} min de leitura
                    </span>
                  </p>
                </div>
              </div>
            </Link>
          </React.Fragment>
        )
      })}
    </div>
  )
}
